<script setup lang="ts">
import DashboardFornecedor from '@/pages/admin/dashboard-fornecedor/index.vue'
import Dashboard from '@/pages/admin/dashboard/index.vue'

definePage({
  meta: {
    action: 'read',
    subject: 'dashboard',
  },
})

// Verificar role do usuário e redirecionar se necessário
const checkUserRole = () => {
  const userData = useCookie('userData').value
  const userRole = userData?.role

  // Se for fornecedor ou espaço de eventos, redirecionar para o dashboard específico
  if (userRole && typeof userRole === 'object') {
    const roleSlug = userRole.slug
    if (roleSlug === 'fornecedor' || roleSlug === 'espaco-eventos')
      return true
  }

  return false
}
</script>

<template>
  <Dashboard v-if="!checkUserRole()" />
  <DashboardFornecedor v-else />
</template>
